import { FilterObject } from '../../../../utils/reportTypes';
import Select from '@vromo/ui/components/Select2';
import React, { ChangeEventHandler, memo } from 'react';
import { FilterRow, selectStyles } from '../../reportFilterModal.style';

interface Props {
    label: string;
    placeholder: string;
    options: FilterObject[];
    value: FilterObject | FilterObject[] | null;
    onChange: ChangeEventHandler<HTMLInputElement>;
    canSelectMultiple?: boolean;
}

const FilterDropdown = ({
    label,
    placeholder,
    options,
    value,
    onChange,
    canSelectMultiple = true
}: Props) => (
    <FilterRow data-testid={label}>
        <label>{label}</label>
        <Select  
            styles={selectStyles}
            {...{ value, onChange, options, placeholder }}
            isClearable
            isMulti={canSelectMultiple}
        />
    </FilterRow>
);

export default memo(FilterDropdown);
